/**
 * FontManager - Centralized font utilities for the app
 * Manages custom font families: Comfortaa (headings) and Noto Sans (body)
 */

export const FONT_COMFORTAA = 'Comfortaa';
export const FONT_NOTO_SANS = 'NotoSans';

/**
 * Font family types for semantic usage
 */
export type FontFamilyType = 'heading' | 'body';

/**
 * Maps semantic font types to actual font family names
 */
export const FontFamily: Record<FontFamilyType, string> = {
  heading: FONT_COMFORTAA,
  body: FONT_NOTO_SANS,
};

/**
 * Get the font family for headings (Comfortaa)
 * Use for: titles, headers, screen names, labels
 */
export function getHeadingFont(): string {
  return FONT_COMFORTAA;
}

/**
 * Get the font family for body text (Noto Sans)
 * Use for: paragraphs, descriptions, captions, form inputs
 */
export function getBodyFont(): string {
  return FONT_NOTO_SANS;
}

/**
 * Font weight mappings for variable fonts
 * Both Comfortaa and Noto Sans support these weights
 */
export const FontWeight = {
  light: '300',
  regular: '400',
  medium: '500',
  semibold: '600',
  bold: '700',
} as const;

export type FontWeightValue = (typeof FontWeight)[keyof typeof FontWeight];
